import { useEffect, useState, type ReactNode, type RefObject } from 'react';
import { createPortal } from 'react-dom';
import mapboxgl from 'mapbox-gl';
import type { UMMapHandle } from '../_components';
import type { Coordinate } from './network';

const CLASS_NAME = 'um-pipe-popup';

/** Mapbox popup anchored on the clicked point; the React content is rendered through a portal. */
export function MapPopup({ mapRef, at, children }: {
  mapRef: RefObject<UMMapHandle>; at: Coordinate; children: ReactNode;
}) {
  const [container] = useState(() => document.createElement('div'));
  const [lng, lat] = at;
  useEffect(() => {
    const map = mapRef.current?.getMap();
    if (!map) return;
    // Closing is driven by React state (✕, map click, building click), never by Mapbox itself.
    const popup = new mapboxgl.Popup({ className: CLASS_NAME, closeButton: false, closeOnClick: false,
      focusAfterOpen: false, maxWidth: '300px', offset: 8 })
      .setLngLat([lng, lat]).setDOMContent(container).addTo(map);
    return () => { popup.remove(); };
  }, [mapRef, container, lng, lat]);
  return <>
    <style>{`.${CLASS_NAME} .mapboxgl-popup-content{width:300px;box-sizing:border-box;padding:12px 16px 16px 13px;border-radius:4px}`}</style>
    {createPortal(children, container)}
  </>;
}
